import React from "react"

const AlertContext = React.createContext()

export function AlertProvider(props) {
  const [alertas, setAlertas] = React.useState([])

  React.useEffect(() => {
    if (alertas.length > 0) {
      if (!alertas.some((e) => e.open === true)) {
        setAlertas([])
      }
    }
  }, [alertas])

  const eliminarAlerta = React.useCallback((rand, time) => {
    setTimeout(() => {
      // ✅ Usar el callback de actualización de estado para setAlertas
      setAlertas((prevAlertas) => {
        // Mapeamos el array inmutablemente para actualizar la alerta
        const alertasCopy = prevAlertas.map((alerta) => {
          if (alerta.pos === rand) {
            return { ...alerta, open: false } // Devolvemos un nuevo objeto (inmutabilidad)
          }
          return alerta
        })
        return alertasCopy
      })
    }, time)
  }, [])

  // useAlert.js - Solución
  const showAlert = React.useCallback(
    ({ message, severity = "info", position = null, time = 5000 }) => {
      let rand = Math.random(1, 23444)
      const nuevaAlerta = {
        message: message,
        severity: severity,
        pos: rand,
        open: true
      }

      // ✅ Usar el callback de actualización de estado para evitar la dependencia de 'alertas'
      setAlertas((prevAlertas) => {
        // Creamos un nuevo array con las alertas previas y la nueva
        const updatedAlertas = [...prevAlertas, nuevaAlerta]

        // Llamamos a eliminarAlerta (debe estar en las dependencias si se usa)
        eliminarAlerta(rand, time)

        return updatedAlertas
      })
    },
    // ✅ Añadir eliminarAlerta como dependencia
    [eliminarAlerta]
  )

  const memData = React.useMemo(() => {
    // const closeAlert = () => {
    //   setOpen(false);
    //   setTimeout(() => {
    //     setPosition(defaultPlace);
    //     setSeverity(defaultColor);
    //     setIcon(defaultIcon);
    //     setMessage(defaultMessage);
    //   }, 2000);
    // };
    return {
      alertas,
      showAlert
      // closeAlert,
    }
  }, [alertas, showAlert])

  return <AlertContext.Provider value={memData} {...props} />
}

export function useAlert() {
  const context = React.useContext(AlertContext)
  if (!context) {
    // eslint-disable-next-line no-throw-literal
    throw "error: alert context not defined."
  }
  return context
}
